module.exports = __webpack_public_path__ + "media/V9.a9d70d3b.mp4";